import angular from 'angular';
import creditworthinessCardComponent from './creditworthinessCard.component';

let creditworthinessCardModule = angular.module('creditworthinessCard', [
])

.component('creditworthinessCard', creditworthinessCardComponent)

.name;

export default creditworthinessCardModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/creditworthiness/creditworthinessCard/creditworthinessCard.js